import React from "react";
import Image from "next/image";
import BaseSkeleton from "../base-skeleton";
import { ClassProps } from "@/lib/types/class-props";
import Icon from "../icons/icon";
import styles from "../../styles/KitArt.module.css";
import Edit from "../icons/lib/edit";
import Pause from "../icons/lib/pause";
import Play from "../icons/lib/play";
import Soundkits from "../icons/lib/soundkits";

export interface GridTileSkeletonProps extends ClassProps {
  type?: string;
}

const GridTileSkeleton = ({ className, type }: GridTileSkeletonProps) => {
  return (
    <div className={`flex p-2 md:p-4 flex-col space-y-1 ${className}`}>
      {type === "creators" ? (
        <>
          <BaseSkeleton className="w-full h-full rounded-full aspect-square" />
          <div className="flex flex-col mt-5 pt-5 items-center justify-center">
            <BaseSkeleton className="w-[120px] h-[16px] lg:h-[32px] rounded" />
          </div>
        </>
      ) : (
        <>
          <BaseSkeleton className="w-full h-full rounded-3xl aspect-square" />
          <div className="flex flex-col mt-5 space-y-1">
            <div className="flex gap-2">
              <BaseSkeleton className="w-[60px] h-[12px] lg:h-[20px] rounded" />
              <BaseSkeleton className="w-[60px] h-[12px] lg:h-[20px] rounded" />
            </div>

            <BaseSkeleton className="w-full h-[16px] lg:h-[32px] rounded" />

            <BaseSkeleton className="w-[120px] h-[12px] lg:h-[20px] rounded" />
          </div>
        </>
      )}
    </div>
  );
};

export default GridTileSkeleton;
